export default __webpack_public_path__ + "static/media/burntoearn.67796673.png";